export const snackbar = {
  data() {
    return {
      snackbar: {
        show: false,
        msg: null,
      },
    };
  },
  methods: {
    openSnackbar(msg) {
      this.snackbar.msg = msg;
      this.snackbar.show = true;
    },
  },
};

export const alert = {
  data() {
    return {
      alert: {
        show: false,
        heading: null,
        msg: null,
      },
    };
  },
  methods: {
    openAlert(heading, msg) {
      this.alert.heading = heading;
      this.alert.msg = msg;
      this.alert.show = true;
    },
  },
};

export default {
  data() {
    return {
      ...snackbar.data(),
      ...alert.data(),
    };
  },
  methods: {
    ...snackbar.methods,
    ...alert.methods,
  },
};
